<template>
  <div class="marker-control-panel" :class="{ 'collapsed': isCollapsed }">
    <div class="panel-title" v-if="!isCollapsed">图例</div>
    <div v-if="!isCollapsed" class="legend-content">
      <button @click="toggleStatusVisibility('正常')" class="normal-btn" :class="{ 'disabled': !statusVisibility.正常 }">
        <div class="btn-left">
          <img src="@/assets/pressure/marker-normal.png" alt="正常" class="status-icon">
          <span class="status-text">正常</span>
        </div>
        <span class="count">{{ statusCounts.正常 }}</span>
      </button>
      <button @click="toggleStatusVisibility('高压')" class="high-pressure-btn"
        :class="{ 'disabled': !statusVisibility.高压 }">
        <div class="btn-left">
          <img src="@/assets/pressure/marker-high.png" alt="高压" class="status-icon">
          <span class="status-text">高压</span>
        </div>
        <span class="count">{{ statusCounts.高压 }}</span>
      </button>
      <button @click="toggleStatusVisibility('低压')" class="low-pressure-btn"
        :class="{ 'disabled': !statusVisibility.低压 }">
        <div class="btn-left">
          <img src="@/assets/pressure/marker-low.png" alt="低压" class="status-icon">
          <span class="status-text">低压</span>
        </div>
        <span class="count">{{ statusCounts.低压 }}</span>
      </button>
      <button @click="toggleStatusVisibility('采集异常')" class="abnormal-btn"
        :class="{ 'disabled': !statusVisibility.采集异常 }">
        <div class="btn-left">
          <img src="@/assets/pressure/marker-error.png" alt="采集异常" class="status-icon">
          <span class="status-text">异常</span>
        </div>
        <span class="count">{{ statusCounts.采集异常 }}</span>
      </button>
      <!-- 供水范围图层按钮 -->
      <button @click="toggleExtLayerVisibility" class="ext-layer-btn" :class="{ 'disabled': !extLayerVisible }">
        <div class="btn-left">
          <div class="blue-circle-icon"></div>
          <span class="status-text">供水范围</span>
        </div>
      </button>
      <!-- 水厂图层按钮 -->
      <button @click="toggleWaterFactoryVisibility" class="water-factory-btn"
        :class="{ 'disabled': !waterFactoryVisible }">
        <div class="btn-left">
          <div class="blue-circle-icon"></div>
          <span class="status-text">水厂范围</span>
        </div>
      </button>
    </div>
    <button @click="toggleCollapse" class="collapse-btn" :class="{ 'collapsed': isCollapsed }">
      <img src="@/assets/pressure/button.png" alt="切换" class="btn-icon">
      <img src="@/assets/pressure/button2.png" alt="切换" class="btn-icon-hover">
    </button>
  </div>
</template>

<script>
export default {
  name: 'MarkerControlPanel',
  data () {
    return {
      isCollapsed: false,
      extLayerVisible: true,
      waterFactoryVisible: true
    }
  },
  props: {
    statusVisibility: {
      type: Object,
      required: true
    },
    statusCounts: {
      type: Object,
      default: () => ({
        正常: 0,
        高压: 0,
        低压: 0,
        采集异常: 0
      })
    },
    extLayerData: {
      type: Array,
      default: () => []
    },
    waterFactoryData: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    toggleStatusVisibility (status) {
      this.$emit('toggle-status', status);
    },
    toggleCollapse () {
      this.isCollapsed = !this.isCollapsed;
    },
    toggleExtLayerVisibility () {
      this.extLayerVisible = !this.extLayerVisible;
      this.$emit('toggle-ext-layer', this.extLayerVisible);
    },
    toggleWaterFactoryVisibility () {
      this.waterFactoryVisible = !this.waterFactoryVisible;
      this.$emit('toggle-water-factory', this.waterFactoryVisible);
    }
  }
}
</script>

<style lang="less" scoped>
.marker-control-panel {
  position: absolute;
  bottom: 65px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 1000;
  background:
    rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px;
  border-radius: 8px;
  transition: all 0.3s ease;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.marker-control-panel.collapsed {
  width: 50px;
  height: 50px;
  padding: 0;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  background:
    rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.legend-content {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

// 面板标题样式
.panel-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 4px;
}

// 按钮样式调整
.ant-btn {
  width: 80px;
  height: 32px;
}

// 按钮基础样式
.normal-btn,
.high-pressure-btn,
.low-pressure-btn,
.abnormal-btn,
.ext-layer-btn,
.water-factory-btn {
  background-repeat: no-repeat;
  background-position: center;
  background-size: 140px 40px;
  background-color: transparent;
  border: none;
  width: 140px;
  height: 40px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 25px;
  position: relative;
}

// 各按钮背景图片
.normal-btn {
  background-image: url('../../../../assets/pressure/u20.svg');
}

.high-pressure-btn {
  background-image: url('../../../../assets/pressure/u25.svg');
}

.low-pressure-btn {
  background-image: url('../../../../assets/pressure/u10.svg');
}

.abnormal-btn {
  background-image: url('../../../../assets/pressure/u15.svg');
}

.ext-layer-btn {
  background-image: url('../../../../assets/pressure/u30.svg');
}

.water-factory-btn {
  background-image: url('../../../../assets/pressure/u30.svg');
}

// 取消选中状态的灰色滤镜
.normal-btn.disabled,
.high-pressure-btn.disabled,
.low-pressure-btn.disabled,
.abnormal-btn.disabled,
.ext-layer-btn.disabled,
.water-factory-btn.disabled {
  filter: grayscale(100%) brightness(0.6);
  opacity: 0.7;
}

// 按钮左侧内容样式
.btn-left {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
}

// 状态图标样式
.status-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

// 蓝色圆形图标样式
.blue-circle-icon {
  width: 20px;
  height: 20px;
  background-color: transparent;
  border: 2px solid #4eb0ff;
  border-radius: 50%;
  flex-shrink: 0;
}

// 灰色圆形图标样式
.gray-circle-icon {
  width: 20px;
  height: 20px;
  background-color: #808080;
  border: 2px solid #808080;
  border-radius: 50%;
  flex-shrink: 0;
}

// 状态文字样式
.status-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

// 数量显示样式
.count {
  font-weight: bold;
  font-size: 14px;
  min-width: 20px;
  text-align: right;
  flex-shrink: 0;
}

// 收缩按钮样式
.collapse-btn {
  position: absolute;
  top: 15px;
  right: 10px;
  width: 30px;
  height: 7px;
  background: transparent;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  z-index: 1001;
}

.collapse-btn:hover {
  background: rgba(255, 255, 255, 0.2);
}

.collapse-btn.collapsed {
  position: static;
  width: 50px;
  height: 50px;
  transform: rotate(180deg);

  img {
    width: 30px;
    height: 16px;
  }
}

.btn-icon {
  transition: opacity 0.3s ease;
}

.btn-icon-hover {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
}


.collapse-btn:hover .btn-icon {
  opacity: 0;
}

.collapse-btn:hover .btn-icon-hover {
  opacity: 1;
}

// 响应式设计
@media (max-width: 768px) {
  .marker-control-panel {
    bottom: 44px;
    right: 10px;
  }

  .ant-btn {
    width: 70px;
    height: 28px;
    font-size: 12px;
  }
}
</style>
